export default "__VITE_ASSET__BZMWskUj__"